"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealEstateTypeSubType = void 0;
class RealEstateTypeSubType {
}
exports.RealEstateTypeSubType = RealEstateTypeSubType;
//# sourceMappingURL=RealEstateTypeSubType.js.map